import React, { useContext } from "react";
import { CartContext } from "../../contex/CartProvider";
import CartItem from "../../molecules/CartItem";

const BuyNowCart = () => {
  const { cart, updateItem } = useContext(CartContext);
  const [totalCost, setTotalCost] = React.useState(Number);
  React.useEffect(() => {
    setTotalCost(0);
    cart?.forEach((item) =>
      setTotalCost((prevCost) => +prevCost + +item.totalPrice)
    );
  }, [cart]);
  return (
    <div className="mb-6">
      <div className="bg-white rounded-4xl shadow-3xl	 p-6">
        {/* Items Card Area */}
        <div className="h-60 md:h-80 overflow-y-auto px-2 my-4 md:my-6">
          {cart?.map((item, index) => (
            <CartItem
              classes="border border-grey/10 rounded-4xl md:p-2"
              item={item}
              key={index}
              updateItem={updateItem}
              edit={false}
            />
          ))}
        </div>
        <div className="mx-4 md:mx-10">
          {/* Components */}
          <div className="flex justify-between items-center text-grey/80 md:text-base mb-2">
            <div className="">Components:</div>
            <div>$750</div>
          </div>

          {/* Design */}
          <div className="flex justify-between items-center text-grey/80 text-base mb-2">
            <div className="">design:</div>
            <div>$750</div>
          </div>

          {/* manufacturing */}
          <div className="flex justify-between items-center text-grey/80 text-base mb-2">
            <div className="">manufacturing:</div>
            <div>$750</div>
          </div>
          {/* delivery */}
          <div className="flex justify-between items-center text-grey/80 text-base mb-2">
            <div className="">delivery:</div>
            <div>$750</div>
          </div>

          {/* Totals */}
          <div className="flex justify-between items-center text-dark/90 font-medium text-xl mb-4">
            <div className=" ">totals:</div>
            <div>$2750</div>
          </div>
        </div>
        {/* Button Area */}
        <div className="flex flex-col space-y-4 mx-8"></div>
      </div>
    </div>
  );
};

export default BuyNowCart;
